import { Module } from 'vuex';
import { RootState } from '@/plugins/store';
import { AuthState, state } from '@/modules/Auth/store/state';
import { mutations } from './mutations';
import { actions } from '@/modules/Auth/store/actions';
import { getters } from '@/modules/Auth/store/getters';

const module: Module<AuthState, RootState> = {
    state,
    mutations,
    actions,
    getters,
};

export default module;
export type {AuthState};
